export const SET_PRODUCT_PACKAGE = 'SET_PRODUCT_PACKAGE';
export const UPDATE_PRODUCT_PACKAGE = 'UPDATE_PRODUCT_PACKAGE';
